/**
 * Use to debug the initiate api call for app cold start
 * To be used in the config-dummy-text component
 * Only for development purpose
 *
 */

import Service from 'react-reservice';

import { IApiError } from '@webtrader/core/request/api';

export interface IDebugLogItem {
  endpoint: string;
  status: 'success' | 'error';
  errorDetails?: IApiError;
}

export interface IDebugLogContext {
  logs: Record<string, IDebugLogItem>;
}

const defaultContext: IDebugLogContext = {
  logs: {}
};

class DebugLogService extends Service<IDebugLogContext> {
  constructor() {
    super();
    this.context = {
      ...defaultContext
    };
  }

  public log(endpoint: string, status: 'success' | 'error', errorDetails?: any) {
    this.context.logs = {
      ...this.context.logs,
      [endpoint]: {
        endpoint,
        status,
        errorDetails
      }
    };
  }
}

const debugLogService = new DebugLogService();
export default debugLogService;
